var path = '/configuration/defaultHomePage.tpl.html';
var html = "<!--This is an empty html file to display if no tabs are available on UMStudio successful login--!>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;